import { generatePath, useHistory } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { AppRoute } from 'routing/AppRoute.enum'
import { Mutations } from 'api/mutations.enum'
import { Queries } from 'api/queries.enum'
import { DeletePulseSurveyPayload } from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { deletePulseSurvey } from 'api/actions/pulseSurveys/pulseSurveysActions'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { usePulseSurveys } from 'hooks/usePulseSurveys'

import { useGetPulseSurveys } from './useGetPulseSurveys'

export const useDeletePulseSurvey = () => {
    const history = useHistory()

    const queryClient = useQueryClient()

    const { onChangeActivePulseSurvey } = usePulseSurveys()

    const { data } = useGetPulseSurveys()

    const mutation = useMutation<void, AxiosError, DeletePulseSurveyPayload>({
        mutationFn: deletePulseSurvey,
        mutationKey: [Mutations.deletePulseSurvey],
        onSuccess: async (_data, variables) => {
            await queryClient.cancelQueries([
                Queries.getPulseSurveyDetail,
                {
                    surveyUUID: variables.surveyUUID,
                },
            ])

            await queryClient.invalidateQueries([Queries.getPulseSurveys])

            if (!data) {
                return
            }

            const filteredData = data.filter((pulseSurvey) => pulseSurvey.uuid !== variables.surveyUUID)

            const pulseSurvey = filteredData[0]

            if (pulseSurvey) {
                onChangeActivePulseSurvey(pulseSurvey)

                history.push(generateCompanyURI(generatePath(AppRoute.PulseSurveyCreate, { id: pulseSurvey.uuid })))
            } else {
                onChangeActivePulseSurvey(null)

                history.push(generateCompanyURI(generatePath(AppRoute.PulseSurvey)))
            }
        },
    })

    return mutation
}
